import request from '../../utils/request';
import { Result } from '../../models/general';

export interface MigrationStatus {
  pendingAttachments: number;
  pendingUsers: number;
  pendingPayslips: number;
  pendingShifts: number;
  pendingBreaks: number;
  pendingWorkSessions: number;
  pendingCompanyLogos: number;
  pendingPayslipBranding: number;
  pendingFaceImages: number;
  pendingLogAttachments: number;
  pendingLeaveAttachments: number;
  pendingNotificationImages: number;
  pendingClaimAttachments: number;
  totalPending: number;
  totalMigrated: number;
  totalFailed: number;
}

export interface MigrationResult {
  migrated: number;
  failed: number;
  skipped: number;
  failedFiles: string[];
}

export interface OrphanedDbReference {
  category: string;
  filePath: string;
  entityId: string;
}

export interface OrphanedFilesResult {
  orphanedDbReferences: OrphanedDbReference[];
  orphanedDiskFiles: string[];
}

export async function getMigrationStatus(companyId: number): Promise<Result<MigrationStatus>> {
  const response = await request.get<Result<MigrationStatus>>(`BlobMigration/status/${companyId}`);
  return response.data;
}

export async function migrateCompany(companyId: number): Promise<Result<MigrationResult>> {
  const response = await request.post<Result<MigrationResult>>(`BlobMigration/migrate/${companyId}`);
  return response.data;
}

export async function retryFailedMigration(companyId: number): Promise<Result<MigrationResult>> {
  const response = await request.post<Result<MigrationResult>>(`BlobMigration/retry/${companyId}`);
  return response.data;
}

export async function getOrphanedFiles(companyId: number): Promise<Result<OrphanedFilesResult>> {
  const response = await request.get<Result<OrphanedFilesResult>>(`BlobMigration/orphaned/${companyId}`);
  return response.data;
}

// Convenience object for grouped import
export const blobMigrationService = {
  getStatus: getMigrationStatus,
  migrateCompany,
  retryFailed: retryFailedMigration,
  getOrphanedFiles,
};
